jQuery(document).ready(function($) {

  if ( $('.m-video__prompt')[0] ) {
    $('.m-video__prompt').click(function() {
      const $video = $(this).parent();
      const $play  = $video.find('.plyr__control[data-plyr="play"]');

      $video.addClass('m-video--playing');
      $play.trigger('click');

      setTimeout(() => {
        $(this).remove();
      }, 200);
    });
  }

});